import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js'
import { replaceString } from './utils'

export const replaceAllSpecialCharacter = (word: string): string => {
  const gtmWhitespace = word
    .trim()
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // replace all accented characters
    .replace(/[^a-z0-9_.\-\s]/g, ' ') // Remove all character who not alphanumeric
    .replace(/\s+/g, ' ')
    .trim()

  return replaceString(gtmWhitespace, '([/ ])', '-')
}

export const formatToE164 = (rawNumber: string, defaultCountry: CountryCode = 'FR') => {
  const phoneNumber = parsePhoneNumberFromString(rawNumber, defaultCountry)

  if (phoneNumber && phoneNumber.isValid()) {
    return phoneNumber.format('E.164') // Format E.164 : +33612345678
  }

  return null
}

const getRepository = (url: string) => url.split('/')[1]

export const getPathAndRepository = (urlHref: string) => {
  const defaultReturn = { repository: null, pagePath: null }
  let repository
  let pagePath

  if (!urlHref) {
    return defaultReturn
  }

  const firstChar = urlHref[0]

  if (!firstChar || firstChar === '#') {
    return defaultReturn
  }

  if (urlHref.includes('tel:')) {
    pagePath = urlHref
  } else if (urlHref === '/') {
    repository = 'home'
    pagePath = 'home'
  } else if (firstChar === '/') {
    repository = getRepository(urlHref)
    pagePath = urlHref.slice(1)
    pagePath = pagePath[pagePath.length - 1] === '/' ? pagePath.slice(0, -1) : pagePath
  } else if (firstChar === 'h') {
    const url = new URL(urlHref)

    if (url.host.includes('izi-by-edf-renov')) {
      repository = 'izi_renov'
      pagePath = url.pathname.substring(1)
    } else if (url.host.includes('izi-by-edf') || url.host.includes('izi-solutions')) {
      repository = getRepository(url.pathname) || 'home'
      pagePath = url.pathname.substring(1) || 'home'
    } else {
      repository = 'externe'
      pagePath = url.host.replace('www.', '')
    }
  }

  return { repository, pagePath }
}
